/** Tool names the memory agents call, mirrored from the backend. */

export const RECALL_TOOL_NAME = "recall";
export const REMEMBER_TOOL_NAME = "remember";
export const USE_MEMORIES_TOOL_NAME = "use_memories";
export const REVISE_TOOL_NAME = "revise";
export const FORGET_TOOL_NAME = "forget";
export const GET_ONTOLOGY_TOOL_NAME = "get_ontology";
export const UPDATE_ONTOLOGY_TOOL_NAME = "update_ontology";
export const SET_BID_VALUES_TOOL_NAME = "set_bid_values";
export const LIST_MEMORIES_TOOL_NAME = "list_memories";

/** Tool names that render as expandable memory rows in the thread's activity list. */
export const MEMORY_ACTIVITY_TOOL_NAMES = [
  USE_MEMORIES_TOOL_NAME,
  REMEMBER_TOOL_NAME,
  REVISE_TOOL_NAME,
  FORGET_TOOL_NAME,
  SET_BID_VALUES_TOOL_NAME
] as const;
